

var segments, selectedSegment;

jQuery(document).ready(function($) {


	/*
	Responsive jQuery is a tricky thing.
	There's a bunch of different ways to handle
	it, so be sure to research and find the one
	that works for you best.
	*/

	/* getting viewport width */
	var responsive_viewport = $(window).width();

	/* if is below 481px */
	if (responsive_viewport < 481) {

	} /* end smallest screen */

	/* if is larger than 481px */
	if (responsive_viewport > 481) {

	} /* end larger than 481px */

	/* if is larger than 481px */
	if (responsive_viewport < 940) {
		// var containing_menu;
		// var list_item_widths = [];

		// setupTwoRowNav();
		// twoRowNav();
		// var throttledResize = _.throttle(twoRowNav, 100);
		// $(window).resize(throttledResize);
	} /* end larger than 481px */

	/* if is above or equal to 768px */
	if (responsive_viewport >= 940) {


	}

	/* off the bat large screen actions */
	if (responsive_viewport > 1030) {

	}


	function fadeInAllSegments(speed){
		(function fadeinnext(jq){
		    jq.eq(0).filter(':not(.diagram_middle)').animate({opacity: 1}, speed);
		    setTimeout(function() {
		    	(jq=jq.slice(1)).length && fadeinnext(jq);
		    }, 200);		
		})($('#diagram .diagram_segment'));
	};

	if ($('#diagram').length) {
		segments = $('#diagram .diagram_segment');
		$.each(segments, function(index, val) {
			thisElement = $(val);
			if (thisElement.css('display') === "block") {
				selectedSegment = thisElement;
			} else {
				thisElement.css({
					opacity: '0',
					display: 'block'
				});
			};
		});
	};

	if ($('.home').length) {
		fadeInAllSegments(1000);			
	} else if ($('.page-id-14').length) {
		segments.filter(':not(.diagram_middle)').css({opacity: '1'});
	};

	if ($('.home, .page-id-14').length) {
		var middle_segment_image = $('.diagram_middle');
		$('area').on({
			mouseover: function(e) {
				target_segment = $(this).attr('id');
				segments.filter(':not(.'+target_segment+')').stop().animate({opacity: 0}, 100);
				middle_segment_image
					.stop()
					.animate({
						opacity: 0
					}, 200);
			},
			mouseout: function(){
				segments.stop().filter(':not(.diagram_middle)').animate({opacity: 1}, 200);
				middle_segment_image
					.stop()
					.animate({
						opacity: 0
					}, 200);
			}
		});
		$('#diagram_middle').on({
			mouseover: function(event) {
				segments
					.filter(':not(.diagram_middle)')
					.stop()
					.animate({
						opacity: 0
					}, 100);
				middle_segment_image
					.stop()
					.animate({
						opacity: 1
					}, 100);
			},
			mouseout: function(event){
				segments.stop().filter(':not(.diagram_middle)').animate({opacity: 1}, 200);
				middle_segment_image
					.stop()
					.animate({
						opacity: 0
					}, 200);
			}
		});			
	} else if( $('#diagram').length){
		$('area').on({
			mouseover: function(e) {
				target_segment = $(this).attr('id');
				console.log(target_segment);
				segments.filter(':not(.'+target_segment+')').stop().animate({opacity: 0}, 100);
				segments.filter('.'+target_segment).stop().animate({opacity: 1}, 100);
			},
			mouseout: function(){
				selectedSegmentId = $(selectedSegment).attr('id');
				segments.filter(':not(.'+selectedSegmentId+')').stop().animate({opacity: 0}, 200);
				selectedSegment.stop().animate({opacity: 1}, 200);
			}
		});			
	};

	
});